<template>
  <el-container style="overflow: visible; position: relative;">
    <el-header style="height: 122px;" v-if="$route.meta.showHeader !== false">
      <LayoutHeader></LayoutHeader>
    </el-header>
    <el-container class="disheader">
      <!-- <div class="stopBox"></div> -->
      <el-aside v-if="$route.meta.showAside !== false" :width="isCollapse ? '46px' : '262px'" style="overflow: visible; position: relative;">
        <LayoutAside></LayoutAside>
      </el-aside>
      <el-main>
        <router-view class="router-view"></router-view>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import LayoutAside from "./LayoutAside";
import LayoutHeader from "./LayoutHeader";
import { mapGetters } from "vuex";

export default {
  components: { LayoutAside, LayoutHeader },
  computed: {
    ...mapGetters(["isCollapse"]),
  },
};
</script>

<style lang="less" scoped>
.el-container {
  display: flex;
  flex-direction: column;
  height: 100% !important; /* 让页面充满整个视口 */
}

.disheader {
  flex: 1; /* 让 .disheader 占满剩余高度 */
  display: flex;
  overflow: hidden; /* 避免额外滚动 */
  flex-direction:row;
}

.el-aside {
  border: 1px solid rgba(31, 198, 255, 0.4);
  margin: 12px 0 24px 24px;
  height: calc(100% - 38px) ; /* 让 aside 充满 .disheader */
}

.el-main {
  height: calc(100% - 38px) ;
  padding: 0;
  margin: 12px 24px 24px 18px;
  border: 1px solid rgba(31, 198, 255, 0.4);
}

.el-header{
  padding: 0 !important;
}


</style>
<style>
.container-basic {
  width: 100%;
  height: 100%;
  background-color: #07243F;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  z-index: 100;
  overflow: hidden;
}

</style>